import { render, staticRenderFns } from "./BreakpointTabs.vue?vue&type=template&id=4a8ab45d&"
import script from "./BreakpointTabs.vue?vue&type=script&lang=ts&"
export * from "./BreakpointTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports